import Helpers from '@helpers';

const priceChecker = () => {
    $('.price-warning').focusout(function (e) {

        

        const textBox = $(this);
        const hiddenField = $(this).next();
        const textBoxVal = parseInt(textBox.val().toString().replace(/,/g, ''), 10);
        const hiddenFieldVal = parseInt(hiddenField.val().toString(), 10);
        const taghirat = hiddenFieldVal * 0.1;
        const smallChnageUp = hiddenFieldVal + taghirat;
        const smallChnageDown = hiddenFieldVal - taghirat;
        const bigChangeUp = hiddenFieldVal * 2;
        const bigChangeDown = hiddenFieldVal * 0.5;


        if ((textBoxVal > smallChnageUp && textBoxVal < bigChangeUp) || (textBoxVal < smallChnageDown && textBoxVal > bigChangeDown)) {

            $('#priceCheck_10Submit').unbind();
            $('#priceCheck_10Cancel').unbind();
            $('#priceCheck_10 .close-link').unbind();
            $('.modal-mask').unbind();
            $('#priceWrongSubmit').unbind();
            $('#priceWrongCancel').unbind();

            textBox.css('border-color', 'red');

            $('#priceCheck_10').show();
            $('#modalMask').show();
            $('#priceCheck_10Submit').click(confirm);
            $('#priceCheck_10Cancel').click(cancel);
            $('#priceCheck_10 .close-link').click(cancel);
            $('#modalMask').click(cancel);

            function confirm() {
                $('#priceCheck_10').hide();
                $('#modalMask').hide();
                textBox.css('border-color', 'orange');
            }
            function cancel() {
                textBox.css('border-color', '#d7d7d7');
                $('#priceCheck_10').hide();
                $('#modalMask').hide();
                textBox.val(Helpers.Utils.numberWithCommas(hiddenField.val()));
            }
        } else if (textBoxVal > bigChangeUp || textBoxVal < bigChangeDown) {

            $('#priceCheck_10Submit').unbind();
            $('#priceCheck_10Cancel').unbind();
            $('#priceCheck_10 .close-link').unbind();
            $('.modal-mask').unbind();
            $('#priceWrongSubmit').unbind();
            $('#priceWrongCancel').unbind();

            textBox.css('border-color', 'red');
            $('.wrongNumber > span').text(textBox.val().toString());
            $('#priceWrong').show();
            $('#modalMask').show()

            $('#priceWrongSubmit').click(confirm);
            $('#priceWrongCancel').click(cancel);
            var wordInput = $('#correctNumber');

            function confirm() {

                var checkWord = wordInput.val();
                var answer = (checkWord == "صحیح" ? true : false);

                if (answer) {
                    wordInput.val('');
                    $('#priceWrong').hide();
                    $('#modalMask').hide();
                    wordInput.css('border-color', '#d7d7d7');
                    textBox.css('border-color', 'orange');
                } else {
                    wordInput.val('');
                    wordInput.css('border-color', 'red');
                }
            }
            function cancel() {
                textBox.css('border-color', '#d7d7d7');
                $('#priceWrong').hide();
                $('#modalMask').hide();
                textBox.val(Helpers.Utils.numberWithCommas(hiddenField.val()));
                wordInput.css('border-color', '#d7d7d7')
            }
            function correction() {
                const checkWord = wordInput.text();
                return (checkWord == "صحیح" ? true : false);
            }

        }
    });
}

export {
    priceChecker
}
